export const isHostReachable = (checkUrl: string): Promise<boolean> =>
    new Promise((resolve) => {
        const resource = new Image();
        resource.onload = () => resolve(true);
        resource.onerror = () => resolve(false);
        resource.src = checkUrl;
    });
